import { FunctionComponent } from 'react';

import {
  serializationOptionsForStringValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';

import { FilterContext, FilterState } from './Filter';

enum QUERY_PARAMS {
  SEARCH = 'search',
}

export const FilterContextProvider: FunctionComponent<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [searchQuery, setSearchQuery] = useSearchParamState({
    searchParamKey: QUERY_PARAMS.SEARCH,
    stateValueWhenSearchParamIsUnset: '',
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForStringValue,
  });

  const context: FilterState = {
    searchQuery,
    setSearchQuery,
  };

  return <FilterContext.Provider value={context}>{children}</FilterContext.Provider>;
};
